import { Box, Typography, useTheme } from '@mui/material';
import { keyframes, styled } from '@mui/system';
import Lottie from 'lottie-react';
import ERROR_LOTTIE from '../services/close.json';
import Constant from '../services/Constant';
// Animations
const appearIn = keyframes`
  0% { opacity: 0; transform: scale(0.97) translateY(40px); }
  100% { opacity: 1; transform: scale(1) translateY(0); }
`;

const floatPulse = keyframes`
  0%, 100% { box-shadow: 0 2px 32px rgba(0,151,178,0.20); }
  50% { box-shadow: 0 6px 48px rgba(8,85,127,0.19); }
`;

const gradientMove = keyframes`
  0% { background-position: 0% 50%; }
  100% { background-position: 100% 50%; }
`;

const GradientBackground = styled(Box)(({ theme }) => ({
        position: 'absolute',
        inset: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: theme.palette.mode === 'dark'
            ? 'linear-gradient(94.25deg, #010720 0%, #003024 100%)'
            : 'linear-gradient(94.25deg, #e0f7fa 0%, #ffffff 100%)',
        backgroundSize: '200% 200%',
        animation: `${gradientMove} 15s alternate infinite`,
}));

const CardContainer = styled(Box)(({ theme }) => ({
        maxWidth: '640px',
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        borderRadius: '24px',
        boxShadow: theme.palette.mode === 'dark'
            ? '0 20px 40px rgba(0,0,0,0.5)'
            : '0 20px 40px rgba(0,0,0,0.1)',
        padding: '3rem 2.5rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '2rem',
        animation: `${appearIn} 1.2s cubic-bezier(.47,1.64,.41,.8) both`,
        zIndex: 10,
        position: 'relative',
        transition: 'background 0.3s, box-shadow 0.3s',
}));

const PulseCircle = styled(Box)(({ theme }) => ({
        width: '144px',
        height: '144px',
        borderRadius: '50%',
        background: theme.palette.mode === 'dark'
            ? 'linear-gradient(to top right, #23272f, #003024, #23272f)'
            : 'linear-gradient(to top right, #fff, #e0f7fa, #fff)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        animation: `${floatPulse} 3.5s ease-in-out infinite`,
        position: 'relative',
        boxShadow: theme.shadows[3],
        transition: 'background 0.3s',
}));

const VerifiedBadge = styled(Box)(({ theme }) => ({
        position: 'absolute',
        bottom: '-16px',
        right: '-8px',
        width: '48px',
        height: '48px',
        borderRadius: '50%',
        background: theme.palette.mode === 'dark'
            ? 'linear-gradient(to top right, #23272f, #003024, #23272f)'
            : 'linear-gradient(to top right, #fff, #e0f7fa, #fff)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: `2px solid ${theme.palette.background.paper}`,
        boxShadow: theme.palette.mode === 'dark'
            ? '0 4px 12px rgba(0,0,0,0.3)'
            : '0 4px 12px rgba(0,0,0,0.1)',
        transition: 'background 0.3s',
}));

const ForgotPassowrdTokenExpired = () => {
    const theme = useTheme();
    return (
        <Box sx={{ height: '100vh', position: 'relative', overflow: 'hidden', background: theme.palette.background.default }}>
            <GradientBackground>
                <CardContainer>
                    {/* Logo Header */}
                    <Box sx={{ mb: 3 }}>
                        <img src={"/logo.png"} alt="Logo" style={{ height: 48, filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none', transition: 'filter 0.3s' }} />
                    </Box>

                    {/* Lottie + Message */}
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                        <PulseCircle>
                            <Lottie
                                animationData={ERROR_LOTTIE}
                                style={{ width: 120, height: 120 }}
                            />
                            <VerifiedBadge>
                                <Lottie
                                    animationData={ERROR_LOTTIE}
                                    style={{ width: 32, height: 32 }}
                                />
                            </VerifiedBadge>
                        </PulseCircle>

                        <Typography variant="h4" fontWeight={800} textAlign="center" color={theme.palette.text.primary} sx={{
                            paddingTop: '10px',
                            fontFamily: 'DM Sans',
                            letterSpacing: 1,
                            transition: 'color 0.3s',
                        }}>
                            Your Token has expired
                        </Typography>
                        <Typography variant="body1" textAlign="center" maxWidth={400} color={theme.palette.text.secondary} sx={{ transition: 'color 0.3s' }}>
                            Please request a new password reset link to continue.
                        </Typography>
                    </Box>
                </CardContainer>
            </GradientBackground>
        </Box>
    );
};

export default ForgotPassowrdTokenExpired;
